export default __webpack_public_path__ + "static/media/Great.7ca1bcff.svg";